import { useMemo } from 'react';
import { createPortal } from 'react-dom';

export default function usePortal(content, shouldPortal) {
  return useMemo(() => {
    if (shouldPortal && typeof window !== 'undefined') {
      const modalRoot = document.getElementById('modal-root') || document.body;
      return createPortal(content, modalRoot);
    }
    return content;
  }, [content, shouldPortal]);
}
